import * as React from 'react'

import { useTransmit } from '../../TransmitContext'
import { UsernameStep } from './UsernameStep'

export const ForgotPassword: React.FC = () => {
  const { activeScreen } = useTransmit()

  // use V2
  if (['ForgotPassword', 'ResetPassword'].includes(activeScreen.type)) {
    const isResetPassword = activeScreen.type === 'ResetPassword'

    return (
      <UsernameStep
        // eslint-disable-next-line react/jsx-props-no-spreading, react/jsx-no-undef
        {...activeScreen.payload}
        isResetPassword={isResetPassword}
      />
    )
  }
  return null
}
